import styled from "styled-components";
import { Link as LinkScroll } from "react-scroll";
import { Link as LinkRouter } from "react-router-dom";
import { FaBars, FaPlayCircle } from "react-icons/fa";
import * as palette from "../../SCVariables";

export const Nav = styled.div`
  background: ${({ scrollNav }) => (scrollNav ? `${palette.mainBlack}` : "transparent")};
  height: 80px;
  margin-top: -80px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  position: sticky;
  top: 0;
  z-index: 10;
  transition: 0.5s all ease-in-out;

  @media screen and (max-width: 960px) {
    transition: 0.8s all ease;
  }
`;

export const NavContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: 80px;
  z-index: 1;
  width: 100%;
  padding: 0 24px;
  max-width: 1200px;
`;
export const NavLogoContainer = styled(LinkRouter)`
  justify-self: flex-start;
  cursor: pointer;
  display: flex;
  align-items: center;
  text-decoration: none;
`;
export const NavLogoText = styled.h1`
  font-size: 2rem;
  color: ${palette.mainWhite};
  list-style: none;
`;
export const MobileIcon = styled.div`
  display: none;

  @media screen and (max-width: 900px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 60%);
    font-size: 1.8rem;
    cursor: pointer;
    color: ${palette.mainWhite};
  }
`;

export const MobileBars = styled(FaBars)`
  color: ${palette.mainWhite};
`;
export const PlayIcon = styled(FaPlayCircle)`
  color: ${palette.mainWhite};
  margin-left: 5px;
`;
export const NavMenu = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  text-align: center;
  margin-right: -22px;

  @media screen and (max-width: 900px) {
    display: none;
  }
`;
export const NavItem = styled.li`
  height: 80px;
`;
export const NavLinks = styled(LinkScroll)`
  color: ${palette.mainWhite};
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 1rem;
  height: 100%;
  cursor: pointer;

  &.active {
    border-bottom: 3px solid ${palette.mainOrange};
  }
`;
export const NavBtn = styled.nav`
  display: flex;
  align-items: center;

  @media screen and (max-width: 900px) {
    display: none;
  }
`;

export const NavBtnLink = styled(LinkScroll)`
  border-radius: 5px;
  background: transparent;
  white-space: nowrap;
  padding: 10px 22px;
  color: ${palette.mainWhite};
  font-size: 16px;
  outline: none;
  border: 2px solid ${palette.mainOrange};
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: ${palette.mainOrange};
    border: 2px solid ${palette.mainOrange};
    color: ${palette.mainBlack};
  }
`;
